import { render, staticRenderFns } from "./GridPages.vue?vue&type=template&id=fc2736b8&"
import script from "./GridPages.vue?vue&type=script&lang=js&"
export * from "./GridPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc2736b8')) {
      api.createRecord('fc2736b8', component.options)
    } else {
      api.reload('fc2736b8', component.options)
    }
    module.hot.accept("./GridPages.vue?vue&type=template&id=fc2736b8&", function () {
      api.rerender('fc2736b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pages/grid/GridPages.vue"
export default component.exports